const currenciesShortHand: Record<string, string> = {
  RUB: '₽',
  USD: '$',
  KZT: '₸',
  EUR: '€',
};

export const getCurrencyShortHand = (currency_id: string) => {
  return currenciesShortHand[currency_id] ?? currency_id;
};
